import React from 'react';
import './Services.css';

const Services: React.FC = () => {
  const services = [
    {
      title: 'Document Notarization',
      icon: '📋',
      description: 'Complete notarization services for all your important documents.',
      items: ['Affidavits', 'Travel consent letters', 'Certified true copies', 'ID notarization']
    },
    {
      title: 'Legal Document Drafting',
      icon: '⚖️',
      description: 'Professional drafting of legal documents with expert guidance.',
      items: ['Power of Attorney', 'Affidavits', 'NDAs & simple contracts', 'Statutory declarations']
    },
    {
      title: 'Immigration & Visa Services',
      icon: '✈️',
      description: 'Specialized support for immigration and visa applications.',
      items: ['Notarized immigration forms', 'Invitation letters', 'Sponsorship declarations']
    },
    {
      title: 'Business & Corporate',
      icon: '🏢',
      description: 'Corporate notarization services for business professionals.',
      items: ['Incorporation docs', 'Corporate resolutions', 'Powers of attorney for business']
    },
    {
      title: 'Personal Legal Documents',
      icon: '👨‍👩‍👧‍👦',
      description: 'Personal and family document notarization services.',
      items: ['Power of Attorney (personal)', 'Wills acknowledgements', 'Custody/guardianship affidavits']
    },
    {
      title: 'International Documents',
      icon: '🌍',
      description: 'International document services including apostille support.',
      items: ['Notarization for international use', 'Authentication/legalization', 'Apostille support']
    },
    {
      title: 'Specialized Services',
      icon: '⭐',
      description: 'Unique and specialized notary services tailored to your needs.',
      items: ['Remote/virtual notarization', 'Mobile notary services', 'International document support']
    },
    {
      title: 'Convenience Services',
      icon: '🚀',
      description: 'Fast and convenient services designed around your schedule.',
      items: ['Same-day appointments', 'Express notarization', 'At-home/office visits']
    }
  ];

  return (
    <section id="services" className="services-section section">
      <div className="container">
        <div className="services-header text-center mb-12">
          <h2 className="heading-2 mb-4">Our Professional Services</h2>
          <p className="body-lg">
            Comprehensive notary services designed to meet all your legal document needs with 
            professionalism, security, and convenience.
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="service-card"
            >
              <div className="service-header">
                <div className="service-icon">
                  {service.icon}
                </div>
                <div>
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                </div>
              </div>
              
              <ul className="service-list">
                {service.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="service-item">
                    <span className="service-checkmark">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
              
              <div className="service-footer">
                <a 
                  href="#contact" 
                  className="btn btn-secondary btn-sm"
                  aria-label={`Learn more about ${service.title}`}
                >
                  Learn More
                  <span>→</span>
                </a>
              </div>
            </div>
          ))}
        </div>
        
        <div className="services-cta text-center mt-12">
          <h3 className="heading-3 mb-4">Need a Custom Service?</h3>
          <p className="body mb-6">
            Don't see exactly what you need? We offer customized notary solutions for unique requirements.
          </p>
          <a href="#contact" className="btn btn-primary btn-lg">
            <span>💬</span>
            Contact Us Today
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;